import { FC, FieldsetHTMLAttributes, ReactNode } from 'react';

interface RequestDemoFieldsetProps extends FieldsetHTMLAttributes<HTMLFieldSetElement> {
  children: ReactNode;
}

const RequestDemoFieldset: FC<RequestDemoFieldsetProps> = ({ children, ...props }) => {
  return <fieldset className='flex flex-col gap-y-3 gap-x-[1rem] md:grid md:grid-cols-2'
    {...props}>{children}</fieldset>;
};

export default RequestDemoFieldset;
